import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PatientCommunicationAnalytics = () => {
  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/* HERO SECTION */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1920&q=80')`,
          }}
        />
        {/* Dark Blue Overlay */}
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        {/* Content */}
        <div className="relative z-10 text-center px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8"
          >
            Patient Communication & Analytics
          </motion.h1>
          
          {/* Breadcrumb Buttons */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Home
            </Link>
            <span className="text-white text-2xl">|</span>
            <Link 
              to="/services" 
              className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all"
            >
              Services
            </Link>
            <span className="text-white text-2xl">|</span>
            <span className="px-8 py-3 bg-[#39a5d3] text-white rounded-full font-semibold">
              Patient Communication & Analytics
            </span>
          </motion.div>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            
            {/* Left - Image & Tagline */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              {/* Tag */}
              <span className="inline-block px-4 py-2 border border-gray-300 rounded-md text-gray-600 text-sm mb-6">
                PATIENT ENGAGEMENT
              </span>
              
              {/* Tagline */}
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-8">
                The Leading <span className="text-[#19354a]">Patient Communication & AnalyticsPartner</span> To Drive Practice Growth!
              </h2>
              
              <img 
                src="/images/123.png" 
                alt="Patient Communication & Analytics"
                className="w-full max-w-[450px] h-auto mx-auto"
              />
            </motion.div>

            {/* Right - Content */}
            <div>
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                In modern healthcare, effective patient communication is the cornerstone of practice success. Keeping patients informed, engaged, and reminded of their healthcare needs directly impacts appointment show rates, patient retention, and overall practice growth. Our Patient Communication & Analytics services help medical practices automate patient engagement while maintaining the personal touch that builds trust.
              </motion.p>
              
              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                From <strong className="text-[#19354a]">automated appointment reminders</strong> to personalized health campaigns via email and WhatsApp, we create HIPAA-compliant communication systems that reduce no-shows, improve patient satisfaction, and drive revenue. Our analytics dashboards provide real-time insights into patient engagement, helping you make data-driven decisions for practice growth.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="text-gray-700 leading-relaxed mb-6"
              >
                At Docmize, we understand that every patient interaction matters. Whether it's sending preventive care reminders, sharing health tips, or tracking campaign performance, our team ensures your medical practice stays connected with patients while you focus on providing exceptional care.
              </motion.p>

              <motion.p 
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className="text-gray-900 font-semibold leading-relaxed mb-8"
              >
                Transform patient communication into practice growth. Partner with Docmize today!
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <Link 
                  to="/contact" 
                  className="inline-block px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
                >
                  GET A QUOTE
                </Link>
              </motion.div>
            </div>

          </div>
        </div>
      </section>

      

{/* WHY CHOOSE US - BLUE SECTION */}
<section className="relative py-20 overflow-hidden">
  {/* Dark Blue Background */}
  <div 
    className="absolute inset-0"
    style={{
      background: 'linear-gradient(135deg, #0f1c3f 0%, #1a2d5e 50%, #152349 100%)'
    }}
  />
  
  {/* Diagonal Lines Pattern */}
  <div className="absolute inset-0 overflow-hidden">
    {/* Main diagonal lines */}
    <div 
      className="absolute inset-0"
      style={{
        backgroundImage: `repeating-linear-gradient(
          45deg,
          transparent,
          transparent 50px,
          rgba(59, 130, 246, 0.1) 50px,
          rgba(59, 130, 246, 0.1) 52px
        )`
      }}
    />
    {/* Additional accent lines */}
    <div className="absolute top-0 left-[20%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
    <div className="absolute top-0 left-[40%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/30 to-transparent transform rotate-[30deg] origin-top"></div>
    <div className="absolute top-0 left-[60%] w-[3px] h-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent transform rotate-[30deg] origin-top"></div>
    <div className="absolute top-0 left-[80%] w-[2px] h-full bg-gradient-to-b from-transparent via-blue-400/15 to-transparent transform rotate-[30deg] origin-top"></div>
  </div>

  {/* Content */}
  <div className="relative z-10 max-w-7xl mx-auto px-6">
    
    {/* Section Header */}
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4">
        Why Choose Our Patient Communication Services?
      </h2>
      <p className="text-white/70 text-lg">
        Here's why medical practices trust us with their patient engagement:
      </p>
    </motion.div>

    {/* Benefits Grid - 2 Columns */}
    <div className="grid md:grid-cols-2 gap-x-16 gap-y-8 max-w-5xl mx-auto">
      
      {/* Left Column */}
      <div className="space-y-8">
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">HIPAA-compliant email marketing for medical practices and clinics</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">WhatsApp patient campaigns for preventive care and health awareness</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Automated appointment reminders that reduce no-shows significantly</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Comprehensive performance reports on patient engagement metrics</p>
        </motion.div>
      </div>

      {/* Right Column */}
      <div className="space-y-8">
        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Real-time conversion and ROI analytics for healthcare campaigns</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Patient segmentation for personalized healthcare communication</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Data-driven insights to optimize patient retention and growth</p>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex items-start gap-4"
        >
          <span className="text-[#39a5d3] text-2xl font-bold">»</span>
          <p className="text-white text-lg">Multi-channel patient communication tracking and attribution</p>
        </motion.div>
      </div>

    </div>
  </div>
</section>

      {/* OUR SERVICES SECTION */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          
          {/* Section Header */}
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
              Our Patient Communication & Analytics Services
            </h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Comprehensive solutions to engage patients and track healthcare marketing performance
            </p>
          </motion.div>

          {/* Services Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            {/* Service 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Email Marketing for Clinics</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                HIPAA-compliant email campaigns for patient education and health awareness.
              </p>
            </motion.div>

            {/* Service 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">WhatsApp Patient Campaigns</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Personalized health campaigns and appointment reminders via WhatsApp.
              </p>
            </motion.div>

            {/* Service 3 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Automated Appointment Reminders</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Reduce no-shows with automated SMS, email, and WhatsApp reminders.
              </p>
            </motion.div>

            {/* Service 4 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Performance Reports</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Detailed analytics on patient engagement and campaign performance.
              </p>
            </motion.div>

            {/* Service 5 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Conversion & ROI Analytics</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Track patient acquisition costs and marketing ROI with precision.
              </p>
            </motion.div>

            {/* Service 6 - Patient Segmentation */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl p-6 border-2 border-[#19354a] hover:shadow-xl transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#19354a] rounded-xl flex items-center justify-center mb-4">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-[#19354a] mb-3">Patient Segmentation</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Targeted messaging based on patient demographics and health needs.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

     {/* ENTRUST US SECTION */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
      
      {/* Left - Content */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-2">
          Entrust us to Optimize
        </h2>
        <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
          Your Patient Communication,
        </h2>
        <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-2">
          Reduce No-Shows
        </h3>
        <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-8">
          and Drive Practice Revenue.
        </h3>

        {/* Checklist Items */}
        <div className="space-y-5">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Set up HIPAA-compliant email campaigns that educate patients and promote preventive care services.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Implement automated appointment reminders via SMS, email, and WhatsApp to reduce no-shows by up to 40%.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Track patient engagement metrics with real-time analytics dashboards showing campaign performance and ROI.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="flex items-start gap-4"
          >
            <div className="w-6 h-6 bg-[#E85A2C] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-gray-700 leading-relaxed">
              Segment patients for personalized health campaigns that improve retention and lifetime value.
            </p>
          </motion.div>
        </div>
      </motion.div>

      {/* Right - Image */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="flex justify-center"
      >
        <img 
          src="/images/services-2.png" 
          alt="Patient Communication Analytics"
          className="w-full max-w-[500px] h-auto"
        />
         
        
      </motion.div>

    </div>
  </div>
</section>

      {/* BENEFITS SECTION */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    
    {/* Section Header */}
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-16"
    >
      <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-[#19354a] mb-4">
        Reap the Benefits of Patient Communication Services
      </h2>
      <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-6">
        AT <span className="text-[#19354a]">DOCMIZE</span>
      </h3>
      <p className="text-gray-600 max-w-4xl mx-auto leading-relaxed">
        Our patient communication and analytics solutions help medical practices stay connected with patients while tracking performance metrics that drive growth.
      </p>
    </motion.div>

    {/* Benefit 1 - Image Right */}
    <div className="grid lg:grid-cols-2 gap-0 mb-8">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#fff4e6] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
            Email & WhatsApp Campaigns
          </h3>
          <p className="text-gray-700 leading-relaxed">
            We create HIPAA-compliant email and WhatsApp campaigns that keep patients informed about health tips, preventive care, and practice updates. Our personalized messaging drives patient engagement, promotes services, and strengthens the doctor-patient relationship through valuable health content.
          </p>
        </div>
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#e8f4fc]"
      >
        <img 
          src="/images/meta10.png" 
          alt="Patient Communication"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
    </div>

    {/* Benefit 2 - Image Left */}
    <div className="grid lg:grid-cols-2 gap-0 mb-8">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#e6f7f0] order-2 lg:order-1"
      >
        <img 
          src="/images/creative2.png" 
          alt="Appointment Reminders"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#e6f2e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
            Automated Appointment Reminders
          </h3>
          <p className="text-gray-700 leading-relaxed">
            Our automated reminder system sends timely notifications via SMS, email, and WhatsApp before appointments. This significantly reduces no-shows, improves schedule efficiency, and increases practice revenue while freeing up your staff to focus on in-office patient care.
          </p>
        </div>
      </motion.div>
    </div>

    {/* Benefit 3 - Image Right */}
    <div className="grid lg:grid-cols-2 gap-0 mb-8">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#f0e6f7] p-6 lg:p-10 flex items-center border-l-4 border-[#19354a]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#19354a] mb-4">
            Performance Analytics & Reporting
          </h3>
          <p className="text-gray-700 leading-relaxed">
            We provide comprehensive analytics dashboards that track patient engagement metrics, email open rates, appointment confirmations, and campaign ROI. Our detailed reports help you understand what's working and make data-driven decisions to optimize patient communication strategies.
          </p>
        </div>
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#e6e9f7]"
      >
        <img 
          src="/images/creative3.png" 
          alt="Analytics Dashboard"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
    </div>

    {/* Benefit 4 - Image Left */}
    <div className="grid lg:grid-cols-2 gap-0">
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="bg-[#fce8e8] order-2 lg:order-1"
      >
        <img 
          src="/images/meta6.png" 
          alt="ROI Tracking"
          className="w-full h-full min-h-[280px] object-cover"
        />
      </motion.div>
      <motion.div 
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="bg-[#fff0e6] p-6 lg:p-10 flex items-center order-1 lg:order-2 border-r-4 border-[#E85A2C]"
      >
        <div>
          <h3 className="text-2xl lg:text-3xl font-bold text-[#E85A2C] mb-4">
            Conversion & ROI Analytics
          </h3>
          <p className="text-gray-700 leading-relaxed">
            Track exactly which communication channels drive the most patient appointments and revenue. Our conversion tracking shows patient acquisition costs, lifetime value, and marketing ROI, enabling you to invest your budget in the most effective patient engagement strategies.
          </p>
        </div>
      </motion.div>
    </div>

  </div>
</section>


{/* FAQ SECTION */}
<section className="py-16 bg-white">
  <div className="max-w-7xl mx-auto px-6">
    
    {/* Section Header */}
    <motion.div 
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h2 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
        Frequently Asked Questions about
      </h2>
      <h3 className="text-3xl lg:text-4xl font-bold text-[#19354a]">
        Patient Communication Services.
      </h3>
    </motion.div>

    {/* FAQ Content - Image Left, Questions Right */}
    <div className="grid lg:grid-cols-2 gap-12 items-start">
      
      {/* Left - Image */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex justify-center lg:sticky lg:top-24"
      >
        <img 
          src="/images/faq-img.png" 
          alt="FAQ Patient Communication"
          className="w-full max-w-[220px] h-auto"
        />
      </motion.div>

      {/* Right - FAQ Items */}
      <div className="space-y-4">
        {[
          {
            question: "Are your email and WhatsApp campaigns HIPAA-compliant?",
            answer: "Yes! All our patient communication systems are built with HIPAA compliance at the core. We use secure, encrypted platforms for email and WhatsApp messaging, never share protected health information without consent, and follow strict privacy protocols to ensure patient data security."
          },
          {
            question: "How much can appointment reminders reduce no-shows?",
            answer: "Automated appointment reminders can reduce no-shows by 30-40% on average. Our multi-channel reminder system (SMS, email, WhatsApp) ensures patients receive timely notifications in their preferred format, significantly improving appointment attendance and practice revenue."
          },
          {
            question: "What types of patient campaigns do you create?",
            answer: "We create preventive care reminders, seasonal health tips, vaccination campaigns, annual checkup reminders, new service announcements, patient education content, health awareness campaigns, and personalized follow-up messages based on patient history and demographics."
          },
          {
            question: "How do you track ROI from patient communication?",
            answer: "We use advanced analytics to track email open rates, click-through rates, appointment bookings from campaigns, patient engagement metrics, and revenue generated from each communication channel. Our dashboards provide clear ROI data showing which campaigns drive the most patient appointments."
          },
          {
            question: "Can you integrate with our existing practice management system?",
            answer: "Yes! We integrate with major practice management systems and EHR platforms to automate patient communication. This allows us to send personalized reminders, segment patients based on demographics and visit history, and track engagement without disrupting your existing workflows."
          }
        ].map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
          >
            <details className="group">
              <summary className="flex items-center justify-between p-5 bg-[#19354a] rounded-lg cursor-pointer list-none">
                <span className="font-semibold text-white">{faq.question}</span>
                <span className="text-white text-2xl font-light group-open:hidden">+</span>
                <span className="text-white text-2xl font-light hidden group-open:block">−</span>
              </summary>
              <div className="px-5 py-4 bg-gray-50 rounded-b-lg text-gray-700 leading-relaxed -mt-2">
                {faq.answer}
              </div>
            </details>
          </motion.div>
        ))}
      </div>

    </div>
  </div>
</section>

      {/* CTA SECTION */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-4xl font-bold text-[#19354a] mb-6"
          >
            Ready to Transform Your Patient Communication?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-gray-600 text-lg mb-8"
          >
            Let our patient engagement experts help you reduce no-shows, improve patient retention, and drive practice growth through strategic communication.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-8 py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PatientCommunicationAnalytics;